export default function initForms() {
  const isPresent = document.querySelector(".js-open-contact-form");
  if (!isPresent) {
    return;
  }

  const formWrapper = document.querySelector(".contact-form-overlay");
  const triggers = document.querySelectorAll(".js-open-contact-form");
  const close = document.querySelector(".js-close-contact-form");

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", function () {
      formWrapper.classList.add("visible");
    });
  });

  close.addEventListener("click", function () {
    formWrapper.classList.remove("visible");
  });

  window.onkeydown = function (event) {
    if (event.keyCode == 27) {
      formWrapper.classList.remove("visible");
    }
  };
}
